import openErrorModal from "../Error/ErrorModal";
import { openBackendValidationErrorModal } from "../Error/ErrorUtilities";
import { fetchUpdateServiceModal, updateService } from "../HTTPRequests/ServiceRequests";
import Mediator from "../Utilities/Mediator";
import DeleteServiceModal from "./DeleteServiceModal";
import ServiceBaseModal from "./ServiceBaseModal";

export default class UpdateServiceModal extends ServiceBaseModal {
	modalDiv: HTMLDivElement;
	displayPriceSection: boolean;

	constructor() {
		super();
		this.modalDiv = document.createElement('div');
	}

	public addIconClickListener(icon: HTMLImageElement) {
		icon.onclick = (event) => {
			event.stopPropagation();
			document.body.append(this.loadingScreen);
			this.displayPriceSection = false;
			this.fetchUpdateModal(icon.id);
		}
	}

	public addRowClickListener(row: HTMLTableRowElement) {
		row.onclick = () => {
			document.body.append(this.loadingScreen);
			this.displayPriceSection = true;
			this.fetchUpdateModal(row.id);
		}
	}

	private fetchUpdateModal(id: string) {
		fetchUpdateServiceModal(id)
			.then((response: string) => {
				this.openUpdateModal(response, id);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}

	private openUpdateModal(modalHTMLString: string, id: string) {
		document.body.appendChild(this.modalDiv);
		this.modalDiv.innerHTML = modalHTMLString;
		const priceSection = this.modalDiv.querySelector(".service-cost");

		new DeleteServiceModal(id, this.modalDiv).addDeleteModalClickListener();
		this.addUploadImageChangeEventListener();
		this.addModalButtonsClickListeners(id, !!priceSection);
		this.addDescriptionModalEventsListeners(this.modalDiv);

		if (priceSection) {
			this.addInputNumberEventsListeners("#update-service-modal");
		}
	}

	private addModalButtonsClickListeners(id: string, isSimple: boolean) {
		window.onclick = (event) => {
			if (event.target === this.modalDiv.firstElementChild) {
				this.modalDiv.remove();
			}
		}

		const img: HTMLImageElement = document.querySelector('#update-service-modal img[alt="close icon"]');
		img.onclick = () => {
			this.modalDiv.remove();
		}

		const saveButton: HTMLButtonElement = document.querySelector('#save');
		saveButton.onclick = () => {
			this.saveUpdatedService(id, isSimple);
		}
	}

	private saveUpdatedService(id: string, isSimple: boolean) {
		let { valid, serviceFormData } = this.getModalData(isSimple);
		if (valid) {
			document.body.append(this.loadingScreen);
			serviceFormData.append("id", id);
			this.updateService(serviceFormData);
		} else {
			this.form.reportValidity();
		}
	}

	private updateService(serviceFormData: FormData) {
		updateService(serviceFormData)
			.then(() => {
				this.modalDiv.remove();
				Mediator.emit("serviceCrudOperationFinished");
			}, (error) => { //backend error
				openBackendValidationErrorModal(error);
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}
}
